export default __webpack_public_path__ + "static/employees-eea1eb01f83be6321e25fdff02068036.png";